<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" [routerLink]="['/']"></i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">

            {{ bValidation ? 'احراز هویت' :  bVisits ? 'گزارش بازدیدهای دوره ایی' : 'گزارش بازرسی ها' }}

        </a>

    </div>

</div>

<main class="">

    <header class="px-3 py-4">

        <div [formGroup]="searchModel" class="row gx-2 gy-2 px-3">

            <div class="col-12 col-md-3">

                <label class="mb-2">  از تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                    [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" class="input-date form-control p-2 text-end" formControlName="strSDate" />

                </ng-persian-datepicker>

            </div>

            <div class="col-12 col-md-3">

                <label class="mb-2">  تا تاریخ </label>

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                    [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" class="input-date form-control p-2 text-end" formControlName="strEDate" />

                </ng-persian-datepicker>

            </div>

            <ng-container *ngIf="!bValidation">

                <div class="col-12 col-md-3">

                    <label> نتیجه بازرسی </label>

                    <select class="form-select p-2" formControlName="tiFInspection_ResultItem">

                        <option value="-1"> انتخاب کنید </option>

                        <option *ngFor="let item of list_ResultItems" value="{{item.tiFInspection_ResultItem}}">

                            {{item.strComment}}

                        </option>

                    </select>

                </div>

            </ng-container>

            <div class="col-12 col-md-1 d-flex justify-content-center align-items-center">

                <button class="btn btn-primary w-100" (click)="searchInspection()"> جستجو </button>

            </div>

        </div>

    </header>

    <div dir="rtl" class="main-result px-3">

        <div class="row gx-2 gy-2 gy-md-0 px-3 py-2">

            <div class="col-12">

                <input type="text" class="form-control" placeholder="جستجو کنید" (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="px-3 table-responsive overflow-auto" style="height:76vh;">

            <table class="table border border-2 mt-1 table-responsive table-striped overflow-auto">

                <thead class=" ">

                    <tr class="text-center">

                        <th scope="col" class=""> # </th>

                        <th scope="col" class=""> عملیات </th>

                        <th scope="col" class="">  {{ bValidation ? 'تاریخ' :  bVisits ? 'تاریخ بازدید' : 'تاریخ بازرسی' }} </th>

                        <th scope="col" class=""> راننده </th>

                        <th scope="col" class=""> پلاک  </th>

                        <th scope="col" class=""> نوع خودرو </th>

                        <ng-container *ngIf="!bVisits && !bValidation">

                            <th scope="col" class=""> نتیجه بازرسی </th>

                        </ng-container>

                        <ng-container *ngIf="bValidation">

                            <th scope="col" class=""> وضعیت </th>

                        </ng-container>


                    </tr>

                </thead>

                <tbody>

                    <tr class="text-center  dirI " *ngFor="let item of list_Inspections;let i=index">

                        <th class="text-secondary"> {{ i + 1 | faNum }} </th>

                        <td class="text-secondary">

                            <i class="fa fa-eye fa-lg mx-2 pointer" title="مشاهده" (click)="openModal(item)"></i>

                        </td>

                        <td class="text-center"> {{ item.strDate | faNum }} </td>

                        <td class="text-center"> {{ item.strMobile_strFullName }} </td>

                        <td class="text-center"> {{ item.strVehicleNo | faNum }} </td>

                        <td class="text-center"> {{ item.strMobileType_strComment | faNum }} </td>

                        <ng-container *ngIf="!bVisits && !bValidation">

                            <td class="text-center">

                                {{ item.strFirst_FInspection_ResultItem_strComment | faNum }}

                            </td>

                        </ng-container>

                        <ng-container *ngIf="bValidation">

                            <td class="text-center">

                                {{ item.strValidationStatus }}

                            </td>

                        </ng-container>


                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- Inspections Report -->

<div *ngIf="!bVisits" class="modal fade rtl " id="Inspection_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> مشاهده اطلاعات ثبت شده  </h5>

                <button type="button" class="btn-close"

                    data-bs-dismiss="modal" aria-label="Close">

                </button>

            </div>

            <form [formGroup]="inspection_Model" class="modal-body overflow-auto row gx-2 p-3" style="max-height:70vh;">

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }"

                    *ngFor="let item of list_Items; let index = index"

                    class="row gx-1 gy-2 gy-md-0 col-12 p-2 mb-3

                    justify-content-between align-items-center border border-2">

                    <div class="col-12 col-md-4">

                        <span> {{ item.strTitle }} :  </span>

                    </div>

                    <div class="col-12 col-md-4 d-flex justify-content-md-center align-items-center">

                        <ng-container *ngFor="let radio of splitItems(item.strItems); let radioIndex = index">

                            <input type="radio" class="mx-2 pointer" [name]="item.iFInspection_Items"> {{ radio }}

                        </ng-container>

                    </div>

                    <div class="col-12 col-md-4 d-flex justify-content-center align-items-center">

                        <input type="text" class="form-control" placeholder="توضیحات"

                        (change)="setValue_Description(index,$event.target.value)">

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }"

                    class="d-flex flex-column align-items-start justify-content-center border border-2 p-2 mb-3">

                    <div class="d-flex align-items-center" *ngFor="let item of list_ResultItems; let index = index">

                        <input type="checkbox">

                        <span class="mx-2"> {{ item.strComment }} </span>

                    </div>

                    <div class="date-container" *ngIf="inspection_Model.get('tiFirst_FInspection_ResultItem')?.value == 1" class="mt-2">

                        <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" class="form-control" formControlName="strDeadlineDate" placeholder="* تاریخ مهلت رفع عیوب"/>

                        </ng-persian-datepicker>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" *ngIf="list_ValueItems.length && false" class="d-flex flex-column align-items-start justify-content-center border border-2 p-2 mb-3">

                    <div class="d-flex align-items-center" *ngFor="let item of list_ResultItems_Review; let index = index">

                        <input type="checkbox" [disabled]="isCheckboxDisabled_Review(item,checkbox.checked)"

                            [title]="isCheckboxDisabled_Review(item,checkbox.checked) == true ? 'یک مورد انتخاب شده است' : '' "

                            #checkbox (click)="setValue_ResultItem_Review(item,checkbox.checked)">

                        <span class="mx-2"> {{ item.strComment }} </span>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" class="d-flex flex-column align-items-start justify-content-center border border-2 p-2">

                    <div class="d-flex align-items-center">

                        <input type="checkbox" formControlName="bThirdInsurance">

                        <span class="mx-2">  بیمه شخص ثالث </span>

                    </div>

                    <div class="d-flex align-items-center">

                        <input type="checkbox" formControlName="bBodyinsurance">

                        <span class="mx-2">  بیمه بدنه </span>

                    </div>

                    <div class="date-container" *ngIf="inspection_Model.get('bThirdInsurance')?.value || inspection_Model.get('bBodyinsurance')?.value" class="mt-2">

                        <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" class="form-control" formControlName="strInsuranceValidityDate" placeholder="* مدت اعتبار بیمه نامه"/>

                        </ng-persian-datepicker>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" class="row gx-1 gy-2 gy-md-0 pb-3 border border-2 mt-3">

                    <div class="col-12 col-md-6 d-md-flex align-items-center justify-content-center mt-3">

                        <div class="col-12 col-md-4">

                            <span class="col-12 col-md-6"> * نام بازرس تجهیزات :  </span>

                        </div>

                        <div class="col-12 col-md-7 mt-2 mt-md-0">

                            <input type="text" class="form-control col-12 col-md-6" formControlName="strEquipmentInspector">

                        </div>

                    </div>

                    <div class="col-12 col-md-6 d-md-flex align-items-center justify-content-center mt-3">

                        <div class="col-12 col-md-4">

                            <span class="col-12 col-md-6"> * نام بازرس ایمنی :  </span>

                        </div>

                        <div class="col-12 col-md-7 mt-2 mt-md-0">

                            <input type="text" class="form-control col-12 col-md-6" formControlName="strSafetyInspector">

                        </div>

                    </div>

                    <div class="col-12 mt-3 px-2 pe-md-4">

                        <textarea class="form-control"

                            style="height: 120px; max-height: 120px;resize: none;"

                            placeholder="توضیحات خود را وارد کنید" formControlName="strComment">

                        </textarea>

                    </div>

                </div>

            </form>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<!-- Periodic Report -->

<div *ngIf="bVisits" class="modal fade rtl " id="PeriodicVisit_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> مشاهده اطلاعات ثبت شده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <form [formGroup]="periodicVisits_Model" class="modal-body overflow-auto row gx-2 p-3" style="max-height:70vh;">

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    *ngFor="let item of list_Items; let index = index" 
                    
                    class="row gx-1 gy-2 gy-md-0 col-12 p-2 mb-3 justify-content-between align-items-center border border-2">

                    <div class="col-12 col-md-4">

                        <span> {{  item.strTitle }} :  </span>

                    </div>

                    <div class="col-12 col-md-4 d-flex justify-content-md-center align-items-center">

                        <ng-container *ngFor="let radio of splitItems(item.strItems); let radioIndex = index">

                            <input type="radio" class="mx-2 pointer" [name]="item.iFInspection_Items"> {{ radio }} 

                        </ng-container>

                    </div>

                    <div class="col-12 col-md-4 d-flex justify-content-center align-items-center">

                        <input type="text" class="form-control" placeholder="توضیحات">

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    class="row gx-1 gy-2 gy-md-0 pb-3 border border-2">

                    <div class="col-12 mt-3 px-2 pe-md-4">

                        <textarea class="form-control" 
                        
                            style="height: 120px; max-height: 120px;resize: none;"
                            
                            placeholder="توضیحات خود را وارد کنید" formControlName="strComment">
                        
                        </textarea>

                    </div>
    
                </div>

            </form>
        
            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="Validation_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> مشاهده اطلاعات ثبت شده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <form class="modal-body overflow-auto row gx-2 gy-2 p-3 px-4" style="max-height:70vh;">

                <p class="col-12"> تاریخ : 

                    <span style="color: navy;"> 
                        
                        {{ validation_Obj.strTime | faNum }} --
                    
                    </span>
                        
                    <span style="color: navy;"> 
                        
                        {{ validation_Obj.strDate | faNum }} 
                    
                    </span>
               
                </p>

                <p class="col-12"> نام راننده : 

                    <span style="color: navy;"> 
                        
                        {{ validation_Obj.strMobile_strFullName | faNum }} 
                    
                    </span>
                        
                </p>

                <p class="col-12"> شماره پلاک : 

                    <span style="color: navy;"> 
                        
                        {{ validation_Obj.strVehicleNo | faNum }} 
                    
                    </span>
                        
                </p>

                <p class="col-12"> وضعیت : 

                    <span style="color: navy;"> 
                        
                        {{ validation_Obj.strValidationStatus | faNum }} 
                    
                    </span>
                        
                </p>

                <div class="border border-2 d-flex flex-column justify-content-center align-items-center col-12 col-md-6 p-2">

                    <p class="border-bottom border-2 pb-1 w-50 text-center" style="border-color: navy!important;"> تصویر ارسالی </p>

                    <img width="100%" height="100%"  style="max-height: 315px;object-fit: contain;"
                    
                        src="{{ validation_Obj.strValidationImage ? 'data:image/jpeg;base64,' + validation_Obj.strValidationImage : '../../../assets/Img/no-image.png' }}">

                </div>

                <div class="border border-2 d-flex flex-column justify-content-center align-items-center col-12 col-md-6 p-2">

                    <p class="border-bottom border-2 pb-1 w-50 text-center" style="border-color: navy!important;"> تصویر خودرو </p>

                    <img width="100%" height="100%"  style="max-height: 315px;object-fit: contain;"
                    
                        src="{{ validation_Obj.strMobileImage ? 'data:image/jpeg;base64,' + validation_Obj.strMobileImage : '../../../assets/Img/no-image.png' }}">

                </div>

                <div id="map2" class="fixed-mapCluster border border-2">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">
    
                    </div>
    
                </div>
            
            </form>
        
            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>